import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createExercise,
    updateExercise,
    clearMessages as clearExerciseMessages
} from '../../../redux/slices/admin/exerciseSlice'; // Adjust the import path as necessary

const ExerciseModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        training_name: '',
        training_category_id: '',
        setsweight_or_timedistance: '',
        sets: '3',
        reps: '10',
        video_url: '',
        notes: ''
    });

    const successMessage = useSelector((state) => state.exercises?.successMessage);
    const errorMessage = useSelector((state) => state.exercises?.error);
    const exercises_categories_min = useSelector((state) => state.app_options?.exercises_categories_min);

    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                training_name: initialData.training_name || '',
                training_category_id: initialData.training_category_id || '',
                setsweight_or_timedistance: initialData.setsweight_or_timedistance || '',
                sets: '3',
                reps: '10',
                video_url: initialData.video_url || '',
                notes: initialData.notes || ''
            });
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const payload = {
            id: isEditMode ? initialData.id : undefined, // Include id if editing
            training_name: formData.training_name,
            training_category_id: formData.training_category_id,
            setsweight_or_timedistance: formData.setsweight_or_timedistance,
            sets: '3',
            reps: '10',
            video_url: formData.video_url,
            notes: formData.notes
        };

        if (isEditMode) {
            await dispatch(updateExercise(payload)); // Send payload directly
        } else {
            await dispatch(createExercise(payload)); // Send payload directly
        }
    };

    const handleClose = () => {
        dispatch(clearExerciseMessages());
        // Clear the form data only when the modal is closed
        setFormData({
            training_name: '',
            training_category_id: '',
            setsweight_or_timedistance: '',
            sets: '3',
            reps: '10',
            video_url: '',
            notes: ''
        });
        closeModal();
    };

    if (!isOpen) return null;

    

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="modalExerciseLabel">{isEditMode ? 'Edit Exercise' : 'Create New Exercise'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-body px-md-5 pb-md-4">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        placeholder="Title"
                                        className="form-control form-control-lg"
                                        name="training_name"
                                        value={formData.training_name}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-select form-select-lg"
                                        name="training_category_id"
                                        value={formData.training_category_id}
                                        onChange={handleFormChange}
                                        required
                                    >
                                    <option value="">Select Category</option>
                                    {exercises_categories_min && exercises_categories_min?.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.category_name}
                                        </option>
                                    ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-select form-select-lg"
                                        name="setsweight_or_timedistance"
                                        value={formData.setsweight_or_timedistance}
                                        onChange={handleFormChange}
                                        required
                                    >
                                        <option value="" disabled>Select Type</option>
                                        <option value="WEIGHT-SETS">⟳ Set and Rep</option>
                                        <option value="TIME-DISTANCE">🕒 Time and Distance</option>
                                    </select>
                                </div>
                                <div className="col-md-6" style={{display:'none'}}>
                                    <input
                                        type="text"
                                        placeholder={(formData.setsweight_or_timedistance == 'TIME-DISTANCE') ? 'Time' : 'No. of Sets'}
                                        className="form-control form-control-lg"
                                        name="sets"
                                        value='3'
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6" style={{display:'none'}}>
                                    <input
                                        type="text"
                                        placeholder={(formData.setsweight_or_timedistance == 'TIME-DISTANCE') ? 'Distance' : 'No. of Reps'}
                                        className="form-control form-control-lg"
                                        name="reps"
                                        value='10'
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        placeholder="Video Url"
                                        className="form-control form-control-lg"
                                        name="video_url"
                                        value={formData.video_url}
                                        onChange={handleFormChange}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <textarea
                                        className="form-control form-control-lg"
                                        placeholder="Notes"
                                        rows="3"
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleFormChange}
                                    ></textarea>
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                    {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ExerciseModal;